export const API_BASE_URL = "/api/request";


/**
 * Запрос для отправки заявки
 * **/
export const productRequest = async (data) => {
    try {
        const response = await fetch(API_BASE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error("Ошибка при отправке заявки");
        }


        console.log(response);
        return await response.text();
    } catch (error) {
        throw error;
    }
};